module.exports = __webpack_public_path__ + "img/zhuozi_notice.44d34806.png";